import { create } from "zustand";
import { getCorporateCardRequests } from "../api";
import { devtools } from "zustand/middleware";
import { ROLES } from "shared/config";

const createUserQueueSlice = devtools((set) => ({
  userData: null,
  setUserData: (val) => {
    set((state) => ({ userData: val }));
  },
  userError: "",
  getUserData: async () => {
    set({ userError: "" });
    try {
      const response = await getCorporateCardRequests(ROLES.USER);
      set({ userData: response.data.data });
      set({ userError: "" });
    } catch (error) {
      set({ userError: error?.message });
      set({ data: null });
    }
    set({ dataKey: "user" });
  },
}));

const createSupervisorQueueSlice = devtools((set) => ({
  supervisorData: null,
  setSupervisorData: (val) => {
    set((state) => ({ supervisorData: val }));
  },
  supervisorError: "",
  getSupervisorData: async () => {
    set({ supervisorError: "" });
    try {
      const response = await getCorporateCardRequests(ROLES.SUPERVISOR);

      set({ supervisorData: response.data.data });
      set({ supervisorError: "" });
    } catch (error) {
      set({ supervisorError: error?.message });
      set({ data: null });
    }
    set({ dataKey: "supervisor" });
  },
}));

const createAdditionalAcceptorQueueSlice = devtools((set) => ({
  additionalAcceptorData: null,
  setAdditionalAcceptorData: (val) => {
    set((state) => ({ additionalAcceptorData: val }));
  },
  additionalAcceptorError: "",
  getAdditionalAcceptorData: async () => {
    set({ additionalAcceptorError: "" });
    try {
      const response = await getCorporateCardRequests(
        ROLES.ADDITIONAL_ACCEPTOR
      );

      set({ additionalAcceptorData: response.data.data });
      set({ additionalAcceptorError: "" });
    } catch (error) {
      set({ additionalAcceptorError: error?.message });
      set({ data: null });
    }
    set({ dataKey: "additional-acceptor" });
  },
}));

const createCardRequestsSlice = devtools((set) => ({
  tabKey: "user",
  setTabKey: (val) => {
    set((state) => ({ tabKey: val }));
  },
  error: "",
  setError: (val) => {
    set((state) => ({ error: val }));
  },
  errorKey: null,
  setErrorKey: (val) => {
    set((state) => ({ errorKey: val }));
  },
  loading: false,
  setLoading: (val) => {
    set((state) => ({ loading: val }));
  },
  dataKey: null,
  setDataKey: (val) => {
    set((state) => ({ dataKey: val }));
  },
  data: null,
  setData: (val) => {
    set((state) => ({ data: val }));
  },
}));

export const useCorporateCardRequestsStore = create((...a) => ({
  ...createUserQueueSlice(...a),
  ...createSupervisorQueueSlice(...a),
  ...createAdditionalAcceptorQueueSlice(...a),
  ...createCardRequestsSlice(...a),
  ...{
    name: "card-requests-storage",
    getStorage: () => sessionStorage,
  },
}));

export default useCorporateCardRequestsStore;
